$(document).ready(function(){
/************ Product Slider on Homepage *********************/
  $('.custom-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    swipe: 'false',
swipeToSlide: 'false',
touchMove: 'false',
draggable: 'false',
    fade: true,
    speed: 500,
    infinite: true,
    cssEase: 'ease-in-out',
    touchThreshold: 100,
    dots: false,
    prevArrow: false,
    nextArrow: false
});
  
  /*****************Fixed Scroll On Homepage *************/
$('.hm-lt-sticky-section-left-slider').slick({
    dots: true,
    prevArrow: false,
    nextArrow: false
});
//   if ($(window).width() < 749) {
//     $('.instaslider').slick({
//     dots: false,
//    slidesToShow: 1,
//   slidesToScroll: 1,
//     prevArrow: false,
//     nextArrow: false
// });
//   }
//   else{
//   $('.instaslider').slick({
//     dots: false,
//    slidesToShow: 4,
//   slidesToScroll: 4,
//     prevArrow: false,
//     nextArrow: false
// });
//   }
})



////////////////stop-scroll-class//////////////////////////////////////////////////
// // Jab ".custom-cart-icon-box" par click hota hai, body mein "stop-scroll" class add hoti hai
// $('body').on('click', '.custom-cart-icon-box', function() {
//     $('body').addClass('stop-scroll');
// });

// // Jab ".close-cart-img" par click hota hai ya ".ans-cst-cart-fixed" ke bahar kisi aur jagah click hota hai
// $('body').on('click', '.close-cart-img, .ans-cst-cart-fixed', function(event) {
//     // Isse ensure karte hain ki ".ans-cst-cart-fixed" ke andar click nahi kiya gaya hai
//     if (!$(event.target).closest('.ans-cst-cart-fixed').length) {
//         $('body').removeClass('stop-scroll');
//     }
// });
